import styled from 'styled-components';
import { spacing } from '../../styles';
import { vars } from '../../theme';

export const Pages = styled.div`
    display: flex;
    justify-content: center;
    gap: ${spacing['8']};
`;

export const Dot = styled.span<{
    $isActive: boolean;
    $color?: string;
    $activeColor?: string;
    $clickable: boolean;
}>`
    height: 8px;
    width: 8px;
    border-radius: ${vars.radius.full};
    display: inline-block;
    background-color: ${({ $isActive, $color, $activeColor }) =>
        $isActive
            ? $activeColor ?? vars.colors.base.accent
            : $color ?? vars.colors.surface.itemStrong};
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;
